<template>
  <div class="container-fluid" ref="container">
    <div class="col-sm-12 col-md-8 offset-md-2">
      <disclamer-modal></disclamer-modal>
      <status-modal :selected-devices="deviceStatus"></status-modal>
      <div class="panel">
        <div class="panel-heading">
          <div class="panel-label">
            <h3 class="header"> Devices </h3>
          </div>
          <div class="panel-toolbar">

          </div>
        </div>
        <div class="panel-body">

          <keyaccount-shop
            :currentUser="currentUser"
            :currentShop="currentShop"
            :shops="shopsBy"
            :users="getUserChilds"
            @change:shops="setShops"
            @change:users="setUser"
            ></keyaccount-shop>
        </div>
        <table-vue
          :url="`${baseUrl}/cubes/devices`"
          trackBy="deviceId"
          dataPath="result"
          :appendParams="{
            userId: (this.currentUser && this.currentUser.id) || '',
            shopId: qsShops,
          }"
          :css="css"
          :useSearch="useSearch"
          :limitOptions="[10, 20, 50]"
          :httpOptions="httpOptions"
          :querySchema="querySchema"
          :paginationSchema="paginationSchema"
          :fields="fields"
          :currentPage="currentPage"
          :perPage="onPage"
          @perPage="changePerPage"
          @currentPage="changCurrentPage"
          id="show-devices--table"
        ></table-vue>
        <div class="panel-footer">
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from 'vuex';

import DisclamerModal from '../../../components/Panel/Modals/disclamer';
import ActionsModal from '../../../components/Panel/Modals/actions';
import StatusModal from '../../../components/Panel/Modals/status-devices';
import Table from 'table-vue/src/components/Table.vue';
import TableStyles from '../../../components/Panel/Table/TableStyles';
import KeyAccountShops from '../../../components/Shared/KeyAccountShops';
import Limit from '../Limit/Limit.vue';
export default {
    name: 'DevicesView',
    data () {
        return {
            currentShop: undefined,
            currentUser: undefined,
            key_account: false,
            useSearch: true,
            bulk: false
        };
    },
    computed:{
        ...mapGetters({
          selectedDevices: 'getSelectedDevices',
          devicesUser: 'getDevicesUser',
          userShops: 'dgetUserShops',
          shopList: 'getShopList',
          getUserChilds: 'getUserChilds',
          getUser: 'getUser',
          selectedUser: 'dgetSelectedUser',
          selectedShops: 'dgetSelectedShops',
          resolvedOnce: 'getResolved',
          qsShops:  'getQsShops',
          fields: 'getDeviceField',
          paginationSchema: 'getDevicesPaginationSchema',
          querySchema: 'getDevicesQuerySchema',
          httpOptions: 'getHttpOptions',
          onPage: 'getDevicesOnPage',
          currentPage: 'getDevicesCurrentPage',
          baseUrl: 'getBaseUrl',
          deviceStatus: 'getDeviceStatus'
        }),
        shopsBy(){
          if(this.currentUser){
            return this.userShops;
          }
          return this.shopList;
        },
        css (){
           const table = {...TableStyles.table,
           ascendingIcon: 'bi-chevron-compact-down',
           descendingIcon: 'bi-chevron-compact-up',
           sortableIcon: 'bi-chevron-expand'};
           return table;
        }
    },
    methods: {
        ...mapActions([
          'setPagination',
          'changeShops',
          'changeUser',
          'GetAllShops',
          'setCurrentDevicePage',
          'setOnPageLimitDevice'
        ]),
        setShops(d){
          this.currentShop = d;
          this.changeShops(d);
        },
        setUser(u){
          this.changeUser(u);
          this.currentUser = u;
        },
        changePerPage (perPage){
          this.setOnPageLimitDevice(perPage);
        },
        changCurrentPage (currentPage){
          this.setCurrentDevicePage(currentPage);
        }
    },
    async mounted(){
      this.shops = await this.GetAllShops();
      if(this.selectedUser && this.selectedUser.id){
        this.currentUser = this.selectedUser;
      }

      if(this.selectedShops && (this.selectedShops.length || this.selectedShops.id)){
        this.currentShop = this.selectedShops;
      }
    },
    components: {
        'keyaccount-shop': KeyAccountShops,
        ActionsModal,
        DisclamerModal,
        StatusModal,
        Limit,
        'table-vue': Table
    }
};

</script>

<style lang="scss">
@media only screen and (max-width: 1400px) {
    #show-devices--table {
        .table {

            th, td {
                padding: unset;
            }
        }
    }
}

@media only screen and (max-width: 1075px) {
    #show-devices--table {
        th, input, select {
            font-size: 1.2vw;
        }

        th, td {
            word-wrap: break-word;
            max-width: 0.5vw;
        }

        select.form-control.selecter {
            font-size: unset;
        }
    }
}

@media only screen and (max-width: 800px) {
    #show-devices--table {

        th, input, select {
            font-size: 1.4vw;
        }
    }
}

@media only screen and (max-width: 530px) {
    #show-devices--table {
        th, input, select.form-control.selecter, .pagination {
            font-size: 2vw;
        }

        th, td {
            max-width: 1vw;
            font-size: 1.5vw;
        }

        .go-to-button {
            font-size: 1.5vw;
            font-weight: 500;
            padding: 0.25rem 0.4rem;
        }
    }
}
</style>
